import { Eved, EventBus } from '@/event-bus'

EventBus.$on(Eved.GENERIC.EXPORT, (e) => {
  //
  console.log('Exporting', e.data)
})



// WEBPACK FOOTER //
// ./src/core/exporter/index.js